'use strict';

module.exports = require('../services/createErrorClass')({
	name: 'MultiplePossibleUsersError',
	soft: true
});
